import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'communication'
const verb = 'get'

export default class OspreyCommunication extends BaseAction {
    constructor(dataKey) {
        const id = '12f1b274-9eea-47fa-9e16-7f62cba78b11'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getAll() {
        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/communication/communication-get.js